import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import StarRatings from 'react-star-ratings';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { db } from './../../config/Fire';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Result } from 'antd';
import { getRestaurant } from './../../reducers';
import LoadingPage from './../../components/LoadingPage';
import * as Constants from './../../constants/nodes_database';
import CommentsByRestoTable from '../../components/tables/CommentsByRestoTable';

function compareDateHour( a, b ) {
    const hourA = moment(a.date + " " + a.hour, 'DD/MM/YYYY HH:mm');
    const hourB = moment(b.date + " " + b.hour, 'DD/MM/YYYY HH:mm');
    if ( hourA.isAfter(hourB) ) {
      return 1;
    }
    if ( hourA.isBefore(hourB) ) {
      return -1;
    }
    return 0;
};

class Comments extends Component {
    state = {
        comments: null,
    }

    getComments = () => {
        const { restaurant } = this.props;
        db.ref(`${Constants.COMMENTSANDRATINGS}`).orderByChild("restaurantId").equalTo(restaurant.id).once("value")
        .then((snapshot) => {
            const comments = [];
            if(snapshot.exists() && snapshot.val() !== null) {
                const commentsAndRatings = snapshot.val() ? snapshot.val() : {};
                for(let index in commentsAndRatings) {
                    const commentAndRating = commentsAndRatings[index];
                    comments.push(commentAndRating);
                }
            }
            this.setState({ comments });
        })
        .catch(err => {
            this.setState({ comments: [] });
        });
        return <LoadingPage />;
    }

    sortComments = (comments) => {
        comments.sort(compareDateHour);
        return comments;
    }

    render() {
        const { restaurant } = this.props;
        const { comments } = this.state;
        return (
            <div>
                {
                    restaurant ?
                        comments !== null ?
                            comments.length === 0 ?
                                <Result status="warning" title="No hay comentarios." />
                                :
                                <Grid style={{ margin: '0', textAlign: 'center', minWidth: '100%'}}>
                                    <Row style={{ paddingTop: '24px' }}>
                                        <Col xs={12} sm={12} md={12} lg={3}>
                                            <span>Comentarios: <span style={{ fontWeight: 'bold'}}>{comments.length}</span></span>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={3}>
                                            <span>Comida: <StarRatings rating={(restaurant.ratingFoodTotal / restaurant.ratingCount)} starRatedColor="#94509b" starEmptyColor="#868686" starDimension="25px" starSpacing="1px"/></span>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={3}>
                                            <span>Servicio: <StarRatings rating={(restaurant.ratingServiceTotal / restaurant.ratingCount)} starRatedColor="#7078b8" starEmptyColor="#868686" starDimension="25px" starSpacing="1px"/></span>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={3}>
                                            <span>Ambiente: <StarRatings rating={(restaurant.ratingAmbientTotal / restaurant.ratingCount)} starRatedColor="#3383FF" starEmptyColor="#868686" starDimension="25px" starSpacing="1px"/></span>
                                        </Col>
                                    </Row>
                                    <Row center="xs" style={{ padding: '24px' }}>
                                        <Col xs={12}>
                                            <CommentsByRestoTable data={this.sortComments(comments)}/>
                                        </Col>
                                    </Row>
                                </Grid>
                            :
                            this.getComments()
                        :
                        <LoadingPage />
                }
            </div>
        );
    }
}

Comments.propTypes = {
    restaurant: PropTypes.object,
};

const mapDispatchToPropsActions = dispatch => ({
    
});

const mapStateToProps = state => ({
    restaurant:  getRestaurant(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(Comments));